module.exports = __webpack_public_path__ + "static/media/twitter.7bceffd2.svg";